import React, { useState, useMemo } from "react"
import SUPPLIER_ORDERS from "./supplier_orders";
interface CustomTableProps {
  data: any;
}


const SUPPLIER_ERROR_DETAIL: React.FC<CustomTableProps> = ({ data }) => {
  const [errors_status, setErrors_status] = useState(false);
  console.log(data)
  return (
    <div>
      <SUPPLIER_ORDERS
        redirect= {"SUPPLIER_INVOICE_TS"}
        setErrors_status={setErrors_status}
        breadcrumbs={false}
        rfc={data.rfc_business_partner}
        invoice={data.invoice}
      />
    </div>
  );
}


export default SUPPLIER_ERROR_DETAIL;